import React from 'react';
import SpotifyPlayer from '../components/SpotifyPlayer';

const SpotifyTest = () => {
  return (
    <div className="min-h-screen bg-black p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold text-white mb-6">Spotify Player Test</h1>
        <p className="text-white/60 mb-8">
          This is a test page to verify the Spotify player works correctly.
        </p>
        
        <SpotifyPlayer />
      </div>
    </div>
  );
};

export default SpotifyTest;
